export default __webpack_public_path__ + "static/media/splitRow.82ce8ebe.png";